export default __webpack_public_path__ + "static/media/gallery_09.6ceb3736.jpg";